/* Locafy: click the ALREADY-selected colour again to toggle between
   "only this colour's photos" and "all photos".
   Never calls preventDefault/stopPropagation, so normal variant
   selection is never blocked. If this script fails, the page is unaffected. */
(() => {
  const swap = (html) => {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('media-gallery');
    const cur = document.querySelector('media-gallery');
    if (fresh && cur) cur.replaceWith(fresh);
  };

  const init = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker || picker.dataset.lfBound) return;
    picker.dataset.lfBound = '1';

    let showingAll = false;
    let armed = new Set();

    // Snapshot what was checked BEFORE the browser flips the radio on click.
    picker.addEventListener(
      'pointerdown',
      () => { armed = new Set(picker.querySelectorAll('input[type="radio"]:checked')); },
      true
    );

    // A real variant change resets us back to the filtered view.
    picker.addEventListener('change', () => { showingAll = false; });

    picker.addEventListener('click', async (e) => {
      const input = e.target.closest && e.target.closest('input[type="radio"]');
      if (!input || !armed.has(input)) return;   // new selection -> leave it entirely to the theme
      const base = picker.dataset.productUrl;
      if (!base) return;

      showingAll = !showingAll;
      let url = base;
      if (!showingAll) {
        const ids = Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
          .map((i) => i.dataset.optionValueId)
          .filter(Boolean);
        if (ids.length) url = base + '?option_values=' + ids.join(',');
      }
      try {
        swap(await (await fetch(url)).text());
      } catch (err) {
        console.warn('[lf-gallery-toggle]', err);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  init();
})();
